// extracted by mini-css-extract-plugin
export default {"title":"UserOrders_title__3DR8m"};